import { useAuth } from '@/hooks/useAuth';
import { UserTypeEnum } from '@/models/user.model';
import { Navigate } from 'react-router-dom';

export default function Root() {
  const { currentUser } = useAuth();

  if (
    currentUser.account &&
    currentUser.userType === UserTypeEnum.PRACTITIONER
  ) {
    return <Navigate to={`/a/${currentUser.account.name}`} />;
  }

  return <Navigate to="/admin" />;
}
